<app-alert-container></app-alert-container>

<app-confirmation-dialog
  (confirmed)="onStatusReasonConfirmed($event)"
  (cancelled)="onStatusReasonCancelled()"
  >
</app-confirmation-dialog>

<div class="row tournament-overview-wrapper">
  <!-- Left Column: Tournament Information -->
  <div class="col-lg-8 tournament-info-column">
    <div class="ibox">
      <div class="ibox-title">
        <h5>Tournament Information</h5>
      </div>
      <div class="ibox-content">
        <form class="form-horizontal">
          <div class="row">
            <!-- Left Column -->
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-sm-4 control-label">LPGA ID</label>
                <div class="col-sm-8">
                  <input
                    #lpgaIdInput
                    class="form-control"
                    type="text"
                    [(ngModel)]="lpgaIdFormatted"
                    (focus)="onLpgaIdFocus()"
                    (blur)="onLpgaIdBlur()"
                    (input)="onImportSourceIdChange()"
                    name="importSourceId"
                    maxlength="10"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Tournament #</label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      type="text"
                      [(ngModel)]="numberFormatted"
                      (focus)="onNumberFocus()"
                      (blur)="onNumberBlur()"
                      (input)="markDirty()"
                      name="tournamentNumber"
                      maxlength="10"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-4 control-label">Tour</label>
                    <div class="col-sm-8">
                      <select
                        class="form-control"
                        [(ngModel)]="tournament.tourId"
                        (change)="markDirty()"
                        name="tourId"
                        >
                        @for (tour of tours; track tour) {
                          <option [value]="tour.tourId">
                            {{ tour.name }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-sm-4 control-label">Year</label>
                    <div class="col-sm-8">
                      <select
                        class="form-control"
                        [(ngModel)]="tournament.year"
                        (change)="markDirty()"
                        name="year"
                        >
                        @for (year of availableYears; track year) {
                          <option [value]="year">
                            {{ year }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Right Column -->
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-4 control-label">Start Date</label>
                    <div class="col-sm-8">
                      <input
                        type="date"
                        class="form-control"
                        [ngModel]="formatDateForInput(tournament.startDate!)"
                    (ngModelChange)="
                      tournament.startDate = parseInputDate($event); markDirty()
                    "
                        name="startDate"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-4 control-label">End Date</label>
                      <div class="col-sm-8">
                        <input
                          type="date"
                          class="form-control"
                          [ngModel]="formatDateForInput(tournament.endDate!)"
                    (ngModelChange)="
                      tournament.endDate = parseInputDate($event); markDirty()
                    "
                          name="endDate"
                          />
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-4 control-label">Scoring Type</label>
                        <div class="col-sm-8">
                          <select
                            class="form-control"
                            [(ngModel)]="tournament.scoringTypeId"
                            (change)="markDirty()"
                            name="scoringTypeId"
                            >
                            @for (type of tournamentScoringTypes; track type) {
                              <option
                                [value]="type.scoringTypeId"
                                >
                                {{ type.name }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-4 control-label">Purse</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <span class="input-group-addon">$</span>
                            <input
                              class="form-control"
                              type="text"
                              [(ngModel)]="purseFormatted"
                              (focus)="onPurseFocus()"
                              (blur)="onPurseBlur()"
                              (input)="markDirty()"
                              name="purse"
                              maxlength="17"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Full Width Name Field -->
                    <div class="form-group">
                      <label class="col-sm-2 control-label">Name</label>
                      <div class="col-sm-10">
                        <input
                          class="form-control"
                          type="text"
                          [(ngModel)]="tournament.name"
                          (input)="markDirty()"
                          name="name"
                          maxlength="200"
                          required
                          />
                        </div>
                      </div>

                      <div class="row">
                        <!-- Left Column -->
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-sm-4 control-label">Country</label>
                            <div class="col-sm-8">
                              <div class="input-group">
                                <select
                                  class="form-control"
                                  [(ngModel)]="tournament.countryId"
                                  (change)="markDirty()"
                                  name="countryId"
                                  >
                                  @for (country of countries; track country) {
                                    <option
                                      [value]="country.countryId"
                                      >
                                      {{ country.name }}
                                    </option>
                                  }
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-4 control-label">State</label>
                            <div class="col-sm-8">
                              <div class="input-group">
                                <select
                                  class="form-control"
                                  [(ngModel)]="tournament.stateId"
                                  (change)="markDirty()"
                                  name="stateId"
                                  >
                                  @for (state of states; track state) {
                                    <option
                                      [value]="state.stateId"
                                      >
                                      {{ state.name }}
                                    </option>
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Right Column -->
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="col-sm-4 control-label">City</label>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="tournament.city"
                                (input)="markDirty()"
                                name="city"
                                maxlength="100"
                                required
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="col-sm-4 control-label">Created On</label>
                              <div class="col-sm-8">
                                <app-audit-info
                                  [dateUtc]="tournament.createdOnUtc"
                                ></app-audit-info>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="col-sm-4 control-label">Modified On</label>
                              <div class="col-sm-8">
                                <app-audit-info
                                  [dateUtc]="tournament.modifiedOnUtc"
                                ></app-audit-info>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- Right Column: Tournament Settings and Classifications -->
                <div class="col-lg-4 tournament-side-column">
                  <div class="tournament-side-scroll">
                    <!-- Tournament Settings -->
                    <div class="ibox">
                      <div class="ibox-title">
                        <h5>Tournament Settings</h5>
                      </div>
                      <div class="ibox-content">
                        <form class="form-horizontal">
                          <div class="form-group">
                            <label class="col-sm-4 control-label">Status</label>
                            <div class="col-sm-8">
                              <select
                                class="form-control"
                                [ngModel]="status"
                                (ngModelChange)="onStatusChange($event)"
                                name="status"
                                >
                                @for (statusOption of statuses; track statusOption) {
                                  <option
                                    [value]="statusOption.value"
                                    >
                                    {{ statusOption.display }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label class="col-sm-4 control-label">Status Reason</label>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="statusReason"
                                name="statusReason"
                                maxlength="255"
                                />
                              </div>
                            </div>

                            <div class="form-group">
                              <label class="col-sm-4 control-label">TimeOffset from UTC</label>
                              <div class="col-sm-8">
                                <select
                                  class="form-control"
                                  [(ngModel)]="timeOffset"
                                  name="timeOffset"
                                  >
                                  @for (offset of timeOffsets; track offset) {
                                    <option [value]="offset">
                                      {{ offset }}
                                    </option>
                                  }
                                </select>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                      <!-- Tournament Classifications -->
                      <div class="ibox">
                        <div class="ibox-title">
                          <h5>Tournament Classifications</h5>
                        </div>
                        <div class="ibox-content">
                          @for (
                            classification of tournamentClassifications; track
                            classification; let i = $index) {
                            <div
                              class="checkbox"
                              >
                              <label>
                                <input
                                  type="checkbox"
                                  [(ngModel)]="classification.selected"
                                  (change)="markDirty()"
                                  [name]="'classification_' + i"
                                  />
                                  {{ classification.description }}
                                </label>
                              </div>
                            }
                          </div>
                        </div>

                        <!-- External IDs -->
                        <div class="ibox">
                          <div class="ibox-title">
                            <h5>Tournament External IDs</h5>
                          </div>
                          <div class="ibox-content">
                            @if (externalIds.length === 0) {
                              <div class="text-muted">
                                <em>No external IDs defined</em>
                              </div>
                              } @if (externalIds.length > 0) {
                              <div class="table-responsive">
                                <table class="table table-sm table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Organization</th>
                                      <th>External ID</th>
                                      <th style="width: 60px">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (extId of externalIds; track $index) {
                                      <tr>
                                        <td>
                                          @if (extId.isEditing) {
                                            <input
                                              type="text"
                                              class="form-control input-sm"
                                              [(ngModel)]="extId.organization"
                                              [name]="'org_' + $index"
                                              />
                                            } @else {
                                              <span>{{ extId.organization }}</span>
                                            }
                                          </td>
                                          <td>
                                            @if (extId.isEditing) {
                                              <input
                                                type="text"
                                                class="form-control input-sm"
                                                [(ngModel)]="extId.externalId"
                                                (input)="onExternalIdChange($index)"
                                                [name]="'extId_' + $index"
                                                />
                                              } @else {
                                                <span>{{ extId.externalId }}</span>
                                              }
                                            </td>
                                            <td class="text-center">
                                              @if (!extId.isEditing) {
                                                <button
                                                  type="button"
                                                  class="btn btn-xs btn-white"
                                                  (click)="editExternalId($index)"
                                                  title="Edit"
                                                  >
                                                  <i class="fa fa-pencil"></i>
                                                </button>
                                                } @if (extId.isEditing) {
                                                <button
                                                  type="button"
                                                  class="btn btn-xs btn-primary"
                                                  (click)="saveExternalId($index)"
                                                  title="Save"
                                                  >
                                                  <i class="fa fa-check"></i>
                                                </button>
                                              }
                                              <button
                                                type="button"
                                                class="btn btn-xs btn-danger"
                                                (click)="removeExternalId($index)"
                                                title="Remove"
                                                >
                                                <i class="fa fa-trash"></i>
                                              </button>
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                }

                                <button
                                  type="button"
                                  class="btn btn-sm btn-white m-t-sm"
                                  (click)="addExternalId()"
                                  >
                                  <i class="fa fa-plus"></i> Add External ID
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Action Buttons -->
                          <div class="text-right m-t-md tournament-side-actions">
                            @if (!tournament.active) {
                              <button
                                class="btn btn-primary m-r-sm"
                                (click)="setActive()"
                                >
                                <i class="fa fa-check"></i> Mark Active
                              </button>
                            }
                            @if (tournament.active) {
                              <span class="text-success m-r-sm">
                                <i class="fa fa-check-circle"></i> Tournament is ACTIVE
                              </span>
                            }
                            <button
                              class="btn btn-primary"
                              (click)="save()"
                              [disabled]="!isDirty() || isSaving()"
                              >
                              <i class="fa fa-save"></i> Save
                            </button>
                          </div>
                        </div>
                      </div>
